module.exports = __webpack_public_path__ + "static/media/34DSS2.a2bd655b.jpg";